import { useEffect } from 'react';
const PIXEL_ID = '1673698393761692';
const SCRIPT_ID = 'meta-pixel-script';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      loaded?: boolean;
      version?: string;
      push?: unknown;
    };
    _fbq?: unknown;
  }
}

/**
 * Loads the Meta Pixel exactly once and fires a single PageView.
 * Any previously injected pixel scripts / noscript images are removed first so
 * only this pixel (1673698393761692) remains on the page.
 */
export function MetaPixel() {
  useEffect(() => {
    // Remove any other Meta Pixel loaders that may already be on the page.
    document.querySelectorAll<HTMLScriptElement>('script[src*="connect.facebook.net"]').forEach(script => {
      if (script.id !== SCRIPT_ID) {
        script.remove();
      }
    });
    document.querySelectorAll<HTMLImageElement>('img[src*="facebook.com/tr"]').forEach(img => img.remove());
    if (document.getElementById(SCRIPT_ID)) {
      return;
    }

    /* eslint-disable @typescript-eslint/no-explicit-any */
    const bootstrap = () => {
      if (window.fbq) return;
      const n: any = function (...args: unknown[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      window.fbq = n;
      if (!window._fbq) window._fbq = n;
    };
    /* eslint-enable @typescript-eslint/no-explicit-any */

    bootstrap();
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    window.fbq?.('init', PIXEL_ID);
    window.fbq?.('track', 'PageView');
    const noscript = document.createElement('noscript');
    noscript.id = 'meta-pixel-noscript';
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1" alt="" />`;
    document.body.appendChild(noscript);
  }, []);
  return null;
}